import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import {
    Grid,
    Paper,
    Box
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";

import TableHead from "@material-ui/core/TableHead";

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);


function TableGpwisSkeleton() {
    return (
        <div>
            <TableHead>
                <TableRow>
                    <StyledTableCell>
                        <b> Job Created Date</b>
                    </StyledTableCell>
                    <StyledTableCell>
                        <b>Job Id</b>
                    </StyledTableCell>
                    <StyledTableCell>
                        <b>Circuit Name</b>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                        <b>Rake Name</b>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                        <b>Cycle ID</b>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                        <b>Leg No.</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Origin</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Origin Code</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Destination</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Destination Code</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Commodity</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Job at Destination</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Arrival at Serving Station Date Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Arrival at Station Date Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Rake Placement Date Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>RR No.</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>RR Date</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>RR Amount</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>RR Actual Weight</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Chargeable Wt.</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Rake Dep. Time from Stn.</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Rake Dep. Time from Serv. Stn.</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Unloading Start Date Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Unloading End Date Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>No. of wagons unloaded</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Quantity of Cargo (MT)</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Loading Start Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Loading End Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>No. of wagons loaded</b>
                    </StyledTableCell>
                    {/* <StyledTableCell align="center">
                        <b>Quantity of Cargo (MT)</b>
                    </StyledTableCell> */}
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>

                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    {/* <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell> */}
                </TableRow>
                <TableRow>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>

                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    {/* <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell> */}
                </TableRow>
                <TableRow>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>

                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    {/* <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell> */}
                </TableRow>
                <TableRow>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>

                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    {/* <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell> */}
                </TableRow>
            </TableBody>
        </div>
    )
}

export default TableGpwisSkeleton
